import ApiCourts from '@/api/apiCourts'
import Vue from 'vue'
import router from '../router'
import Field from '@/models/field'
import { createActionHelpers } from 'vuex-loading'

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
})

const state = {
  fields: [],
  field: new Field(),
  fieldIsAvailable: null
}

const actions = {
  loadFields(context){
    startLoading(context.dispatch, 'load fields')
    ApiCourts.all((data) => {
      context.commit("updateFields", data)
      endLoading(context.dispatch, 'load fields')
    }, error => {
      console.log(error)
      endLoading(context.dispatch, 'load fields')
    })
  },
  loadField(context, data) {
    startLoading(context.dispatch, 'load field')
    context.commit("updateField", new Field())
    if (data.id){
      ApiCourts.find(data.id, (response) =>{
        data.callBack(response)
        context.commit("updateField", response)
        endLoading(context.dispatch, 'load field')
      }, error => {
        console.log('Error', error)
        endLoading(context.dispatch, 'load field')
      })
    }

  },
  createField(context, field){
    startLoading(context.dispatch, 'creating field')
    ApiCourts.create(field, response => {
      endLoading(context.dispatch, 'creating field')
      router.go(-1)
    }, error => {
      console.log(error)
      endLoading(context.dispatch, 'creating field')
    })
  },
  updateField(context, field){
    startLoading(context.dispatch, 'updating field')
    ApiCourts.update(field,(response)=>{
      endLoading(context.dispatch, 'updating field')
      router.go(-1)
    }, error => {
      endLoading(context.dispatch, 'updating field')
      console.log(error)
    })
  },
  activeField(context, field){
    startLoading(context.dispatch, 'updating field')
    ApiCourts.active(field,(response)=>{
      context.dispatch('loadFields')
      endLoading(context.dispatch, 'updating field')
    }, error => {
      endLoading(context.dispatch, 'updating field')
      console.log(error)
    })
  },
  removeField(context, field){
    startLoading(context.dispatch, 'removing field')
    ApiCourts.delete(field,(response)=>{
      context.dispatch('loadFields')
      endLoading(context.dispatch, 'removing field')
    }, error => {
      endLoading(context.dispatch, 'removing field')
      console.log(error)
    })
  },
  fieldIsAvailable(context,match){
    startLoading(context.dispatch, 'load data')
    ApiCourts.isAvailable(match,response => {
      endLoading(context.dispatch, 'load data')
      context.commit("updateFieldIsAvailable", response.data.data)
    }, error => {
      console.log(error)
      endLoading(context.dispatch, 'load data')
    })
  },
  fieldsAreAvailable(context,matches){
    startLoading(context.dispatch, 'load data')
    ApiCourts.areAvailable(matches,response => {
      endLoading(context.dispatch, 'load data')
      console.log(response.data)
      let dataToCommit = {
        matches:matches,
        serverResponse: response.data.data
      }
      /*Esta mutación está en el state de tournament*/
      context.commit("updateTournamentMatches", dataToCommit)
    }, error => {
      console.log(error)
      endLoading(context.dispatch, 'load data')
    })
  },
  clearFieldIsAvailable(context){
    context.commit("updateFieldIsAvailable", null)
  }
}

const mutations = {
  updateFields(state,data){
    state.field = new Field()
    state.fields = data
  },
  updateField(state,data){
    state.field = data
  },
  updateFieldIsAvailable(state,data){
    state.fieldIsAvailable = data
  }

}

const getters = {
  currentFields(state){
    return state.fields
  },
  currentField(state){
    return state.field
  },
  currentFieldIsAvailable(state){
    return state.fieldIsAvailable
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/fields.js